import type { EdgeId } from '@ipfabric/utils';
import { highlightEdge } from 'components/Graph/commands/edges/highlightEdge';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { EDGE_HIGHLIGHT_THICKNESS } from '../constants';
import { getNodeHighlightedEdges } from './pathLookup/helpers/getNodeHighlightedEdges';

export const edgeMouseOver: GraphCommandFactory<EdgeId> =
  (cmdContext, dispatch) => (edgeId) => {
    const { activeNodeSn, highlightedEdges } =
      cmdContext.getState().pathlookup.pathInspector;
    const nodeHighlightedEdges = getNodeHighlightedEdges(
      activeNodeSn,
      highlightedEdges,
    );
    if (nodeHighlightedEdges === undefined) {
      return;
    }

    const isEdgeHighlighted =
      nodeHighlightedEdges.incomingEdges.includes(edgeId) ||
      nodeHighlightedEdges.outgoingEdges.includes(edgeId);
    // Highlight already highlighted path inspector edge
    if (isEdgeHighlighted) {
      dispatch(highlightEdge, {
        edgeId,
        thickness: EDGE_HIGHLIGHT_THICKNESS,
      });
    }
  };
